import script from "./WardSelect.vue?vue&type=script&lang=ts&setup=true"
export * from "./WardSelect.vue?vue&type=script&lang=ts&setup=true"

import "./WardSelect.vue?vue&type=style&index=0&id=9245ee84&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9245ee84"]])

export default __exports__